import { theme as defaultTheme } from "@mindlercare/ui-web";
import { styled } from "styled-components";

export const ReferralWrapper = styled.div`
  margin: 30px;
  display: flex;
  flex-direction: column;
`;

export const FormContainer = styled.div`
  padding: 24px 24px;
  padding-left: 0;
  width: 893px;
`;

export const RadioButtonWrapper = styled.div`
  display: flex;
  margin-right: 24px;

  p {
    display: flex;
    align-items: center;
  }
`;

export const RadioLabel = styled.span`
  margin-right: 8px;
`;

export const PatientDetailsWrapper = styled.div`
  display: flex;
  gap: 48px;
  padding-top: 24px;
  min-width: 0;
`;

export const SmallText = styled.p`
  font-weight: ${defaultTheme.FONT.WEIGHT.REGULAR};
  font-size: ${defaultTheme.FONT.SIZE.STANDARD};
  padding-top: 10px;
  color: ${defaultTheme.COLORS.DARK_GREEN_TEXT};
`;

export const Signature = styled.p`
  font-weight: ${defaultTheme.FONT.WEIGHT.MEDIUM};
  font-size: ${defaultTheme.FONT.SIZE.STANDARD};
  margin-top: 14px;
  margin-bottom: 24px;
  color: ${defaultTheme.COLORS.DARK_GREEN_TEXT};
`;

export const AddressInput = styled.textarea`
  font-family: ${defaultTheme.FONT.FAMILY.BODY};
  resize: none;
  height: 92px;
  width: 386px;
  border-radius: 8px;
  border: 1px solid ${defaultTheme.COLORS.MIDDLE_GREY};
  padding: 10px;

  &:focus {
    border: 1px solid ${defaultTheme.COLORS.MEDIUM_GREEN};
    outline: none;
    border: 1.5px solid ${defaultTheme.COLORS.MEDIUM_GREEN};
  }

  &:disabled {
    background-color: ${defaultTheme.COLORS.WHITE};
  }
`;

export const BottomContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
  color: ${defaultTheme.COLORS.DARK_GREEN_TEXT};
`;

export const ButtonWrapper = styled.div`
  display: flex;
`;
